export const DEFAULT_DOCUMENT_TITLE = 'Benestream Portal'
